/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Stormtrooper.glb --transform 
Files: Stormtrooper.glb [2.37MB] > C:\Users\alexr\Documents\Development\Lofi site\public\Stormtrooper-transformed.glb [212.01KB] (91%)
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function Stormtrooper(props) {
  const { nodes, materials } = useGLTF("/Stormtrooper-transformed.glb");
  return (
    <group {...props} dispose={null}>
      <primitive object={nodes.spine} />
      <skinnedMesh
        geometry={nodes.Circle011.geometry}
        material={materials["white.001"]}
        skeleton={nodes.Circle011.skeleton}
        position={[-3.206, -0.05, -2.935]}
        rotation={[0, 1.025, 0]}
        scale={2.064}
      />
      <skinnedMesh
        geometry={nodes.Circle012.geometry}
        material={materials["white.001"]}
        skeleton={nodes.Circle012.skeleton}
        position={[-3.206, -0.05, -2.935]}
        rotation={[0, 1.025, 0]}
        scale={2.064}
      />
      <group
        position={[-3.206, -0.05, -2.935]}
        rotation={[0, 1.025, 0]}
        scale={2.064}
      >
        <skinnedMesh
          geometry={nodes.Mesh_1.geometry}
          material={materials["black.002"]}
          skeleton={nodes.Mesh_1.skeleton}
        />
        <skinnedMesh
          geometry={nodes.Mesh_2.geometry}
          material={materials["white.001"]}
          skeleton={nodes.Mesh_2.skeleton}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/Stormtrooper-transformed.glb");
